import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

import MoreOptions from 'ROOT/src/components/formElements/MoreOptions';
import TickBox from 'ROOT/src/components/formElements/TickBox';
import sAction from 'sAction';
import ListViewPagination from 'ROOT/src/components/list/ListViewPagination';

export default class ListViewFooter extends PureComponent {
    addFilter(field, type, value) {
    //    this.props.parent.props.parent.filterClose();
        const prefix = this.props.prefix;
        const modul = this.props.module;
        if (
            modul == 'Contacts' ||
      modul == 'Leads' ||
      modul == 'Prospects' ||
      modul == 'Users'
        ) {
            field = 'last_name';
        } else if (modul == 'Documents') {
            field = 'document_name';
        }
        const filter = {
            field: field,
            type: type,
            value: value,
            footer: true,
        };
        const filters = new Array(filter);

        const data = {
            field: field,
            filters: filters,
            operator: 'and',
            prefix: prefix,
            reload: true,
        };
        if (value != '%%') {
            sAction.addFilter(data);
        } else {
            sAction.removeFilter(data);
        }
    }
    selectPage() {
        const prefix = this.props.prefix;
        sAction.toggleAll(true, prefix);
    }
    selectAll() {
        const prefix = this.props.prefix;
        sAction.dsClear();
        sAction.dsAdd('set', prefix + '/selected', 'all');
        sAction.dsAdd('set', prefix + '/selectPage', true);
        sAction.dsProcess();
    }
    removeSelect() {
        const prefix = this.props.prefix;
        sAction.dsClear();
        sAction.dsAdd('set', prefix + '/selected', []);
        sAction.dsAdd('set', prefix + '/selectPage', false);
        sAction.dsProcess();
    }
    resetWidth() {
        const view = sAction.getViewName();
        const way = view + this.props.module;
        const filterData = sAction.getStorage('listFilterData');
        if (filterData[way]['widthInfo']) {
            filterData[way]['widthInfo'] = [];
            sAction.setStorage('listFilterData', filterData);
            sAction.afterLoadListView(this.props.prefix);
        }
    }

    render() {
        const offset = this.props.offset;
        const rowCount = this.props.rowCount;
        const selectedActive = this.props.selectedActive;
        const page = this.props.page;
        const filter = this.props.filter;

        filter.forEach((field) => {
            if (
                field.field == 'name' ||
                field.field == 'last_name' ||
                field.field == 'document_name'
            ) {
                const filters = field.filters;
                filters.forEach((filter) => {
                    if (filter.type == 'start') {
                        activeLetter = filter.value;
                    }
                });
            }
        });

        const type = this.props.type;
        let pomClass = '';
        if (type == 'rightPanelQuotes') {
            pomClass = ' rightPanelQuotes';
        }

        return (
            <div className="listViewFooter">
                <div className="alphabetContainer footerBlock"></div>

                <ListViewPagination offset={offset}
                    limit={this.props.limit}
                    rowCount={rowCount}
                    rowTotalCount={this.props.rowTotalCount}
                    page={page}
                    prefix={this.props.prefix}
                />
            </div>
        );
    }
}

ListViewFooter.propTypes = {
    filter: PropTypes.array,
    limit: PropTypes.any,
    module: PropTypes.string,
    offset: PropTypes.any,
    page: PropTypes.any,
    prefix: PropTypes.string,
    rowCount: PropTypes.any,
    rowTotalCount: PropTypes.any,
    selected: PropTypes.any,
    selectedActive: PropTypes.bool,
    type: PropTypes.string,
};
